import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { TextButton } from '@xingternal/button';
import { trackEvent } from '@xingternal/hops-tracking';
import { IconExternalLink } from '@xingternal/icons';
import { spaceL } from '@xingternal/tokens';

import { appendQueryParams } from '@/helpers/query-string';

const CultureLinkButton = styled(TextButton)`
  margin-top: ${spaceL};
  > div {
    align-items: flex-start;
  }
`;

type Props = {
  link?: string | null;
};

export const CultureLink: React.VFC<Props> = ({ link }) => {
  const onCultureLinkClick = (): void =>
    trackEvent('PropTrackAction', { PropTrackAction: 'jobs_kununu_culture_further_info' });
  return link ? (
    <CultureLinkButton
      icon={IconExternalLink}
      href={appendQueryParams(link, {
        utm_source: 'xing_jobs',
        utm_medium: 'affiliate',
        utm_content: 'cta_culture_jobs',
        rfr: 'xjp_cta_culture',
      })}
      target="_blank"
      onClick={onCultureLinkClick}
      iconAfter
      size="small"
    >
      <FormattedMessage id="JOBS_JOB_DETAILS_KUNUNU_CULTURE" />
    </CultureLinkButton>
  ) : null;
};
